import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcStars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	id: "star-icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6888 8.0167L16.2045 13.5511C16.3259 13.8184 16.5402 14.0326 16.8074 14.1541L22.3419 16.6698C22.6266 16.7992 22.6266 17.2036 22.3419 17.333L16.8074 19.8487C16.5402 19.9702 16.3259 20.1844 16.2045 20.4516L13.6888 25.9861C13.5594 26.2708 13.155 26.2708 13.0255 25.9861L10.5099 20.4516C10.3884 20.1844 10.1742 19.9702 9.90691 19.8487L4.37248 17.333C4.08775 17.2036 4.08775 16.7992 4.37248 16.6698L9.90691 14.1541C10.1742 14.0326 10.3884 13.8184 10.5099 13.5511L13.0255 8.0167C13.155 7.73197 13.5594 7.73197 13.6888 8.0167Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8295 10.4338L25.7211 12.8721C25.6348 13.062 25.3652 13.062 25.2789 12.8721L24.1706 10.4338C24.0491 10.1665 23.8349 9.95231 23.5676 9.83082L21.1293 8.72248C20.9395 8.6362 20.9395 8.36658 21.1293 8.2803L23.5676 7.17196C23.8349 7.05047 24.0491 6.83627 24.1706 6.56899L25.2789 4.13064C25.3652 3.94083 25.6348 3.94083 25.7211 4.13064L26.8295 6.56899C26.9509 6.83627 27.1652 7.05047 27.4324 7.17196L29.8708 8.2803C30.0606 8.36658 30.0606 8.6362 29.8708 8.72248L27.4324 9.83082C27.1652 9.95231 26.9509 10.1665 26.8295 10.4338Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1706 23.569L25.2789 21.1306C25.3652 20.9408 25.6348 20.9408 25.7211 21.1306L26.8295 23.569C26.9509 23.8363 27.1652 24.0505 27.4324 24.172L29.8708 25.2803C30.0606 25.3666 30.0606 25.6362 29.8708 25.7225L27.4324 26.8308C27.1652 26.9523 26.9509 27.1665 26.8295 27.4338L25.7211 29.8721C25.6348 30.062 25.3652 30.062 25.2789 29.8721L24.1706 27.4338C24.0491 27.1665 23.8349 26.9523 23.5676 26.8308L21.1293 25.7225C20.9395 25.6362 20.9395 25.3666 21.1293 25.2803L23.5676 24.172C23.8349 24.0505 24.0491 23.8363 24.1706 23.569Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcStars;
